import React from "react";
import {CustomCheckBox, CustomHourPiker, CustomView} from "../../../../../../../../components";
import {IWeeksDay} from "../../../../../../../../types/student.interface";
import {IHourTiming} from "../../../../../../../../types/school.interface";

type Props = {
  label?: string;
  onChange: (arg: IWeeksDay) => void;
  defaultValue: IWeeksDay | undefined;
};

const DayInformation = (props: Props) => {
  const undefinedTime = {hour: undefined, minute: undefined};

  return (
    <section>
      <label className="form-week-day-label">{props.label}</label>
      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum">
          <CustomCheckBox
            label="بستن"
            isChecked={props.defaultValue?.close}
            onChecked={() =>
              props.onChange({
                ...props.defaultValue,
                close: !props.defaultValue?.close,
              })
            }
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <label className="form-label">زمان ورود</label>
          <CustomHourPiker
            defaultValue={props.defaultValue?.entranceTime ? props.defaultValue.entranceTime : undefinedTime}
            onChange={(event: IHourTiming) =>
              props.onChange({
                ...props.defaultValue,
                entranceTime: event,
              })
            }
            inputName="ساعت ورود"
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <label className="form-label">زمان خروج</label>
          <CustomHourPiker
            defaultValue={props.defaultValue?.departTime ? props.defaultValue.departTime : undefinedTime}
            onChange={(event: IHourTiming) =>
              props.onChange({
                ...props.defaultValue,
                departTime: event,
              })
            }
            inputName="ساعت خروج"
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <label className="form-label">زمان دریافت</label>
          <CustomHourPiker
            defaultValue={props.defaultValue?.pickupTime ? props.defaultValue.pickupTime : undefinedTime}
            onChange={(event: IHourTiming) =>
              props.onChange({
                ...props.defaultValue,
                pickupTime: event,
              })
            }
            inputName="ساعت دریافت"
          />
        </CustomView.Column>
      </CustomView.Row>
    </section>
  );
};

export default DayInformation;
